import { v1 as uuid } from "uuid";

export const transumsArray = [ 
  {
    name: "type16",
    url: "/transums/Single_Door_Embossed_326_948_Rectangular_Transum_160_Lite.png",
    key: uuid(),
  },

];

export default transumsArray;